export const redirect = {
  title: 'Por favor, aguarde uns segundos.',
  description: 'Estamos conectando com o provedor de autenticação.',
};
